var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-card',{class:[
		_vm.$s.ChoiceCard,
		( _obj = {}, _obj[_vm.$s.selected] = _vm.isSelected, _obj[_vm.$s.disabled] = _vm.isDisabled, _obj ) ],attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.selectSelf}},[_vm._t("default",null,{"selected":_vm.isSelected})],2)}
var staticRenderFns = []

export { render, staticRenderFns }